const nf = new Intl.NumberFormat('pt-BR');
const nfCompact = new Intl.NumberFormat('pt-BR', { notation: 'compact', maximumFractionDigits: 1 });
const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
const usd = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });
const dateTime = new Intl.DateTimeFormat('pt-BR', { dateStyle: 'short', timeStyle: 'short' });
const dateShort = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short' });
const dateLong = new Intl.DateTimeFormat('pt-BR', { day: '2-digit', month: 'short', year: 'numeric' });
const rtf = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto', style: 'short' });

export const fmt = {
  int: (n: number) => nf.format(n),
  compact: (n: number) => (Math.abs(n) < 10_000 ? nf.format(n) : nfCompact.format(n)),
  usdMicros: (micros: number) => usd.format(micros / 1_000_000),
  usd: (v: number) => usd.format(v),
  brlCents: (cents: number) => brl.format(cents / 100),
  pct: (n: number, digits = 0) => `${n.toFixed(digits).replace('.', ',')}%`,
  ms: (n: number | null | undefined) => (n == null ? '—' : n >= 1000 ? `${(n / 1000).toFixed(1).replace('.', ',')} s` : `${n} ms`),
  dateTime: (v: string | Date | null | undefined) => (v ? dateTime.format(new Date(v)) : '—'),
  date: (v: string | Date | null | undefined) => (v ? dateLong.format(new Date(v)) : '—'),
  dayShort: (isoDay: string) => dateShort.format(new Date(`${isoDay}T12:00:00`)).replace('.', ''),
  relative(v: string | Date | null | undefined): string {
    if (!v) return '—';
    const diff = (new Date(v).getTime() - Date.now()) / 1000;
    const abs = Math.abs(diff);
    if (abs < 45) return 'agora';
    if (abs < 3600) return rtf.format(Math.round(diff / 60), 'minute');
    if (abs < 86400) return rtf.format(Math.round(diff / 3600), 'hour');
    if (abs < 86400 * 30) return rtf.format(Math.round(diff / 86400), 'day');
    return dateLong.format(new Date(v));
  },
  cnpj(d: string) {
    const s = d.replace(/\D/g, '').padEnd(14, ' ');
    return `${s.slice(0, 2)}.${s.slice(2, 5)}.${s.slice(5, 8)}/${s.slice(8, 12)}-${s.slice(12, 14)}`.trim();
  },
  phone(d: string | null | undefined) {
    if (!d) return '—';
    const s = d.replace(/\D/g, '');
    if (s.length === 11) return `(${s.slice(0, 2)}) ${s.slice(2, 7)}-${s.slice(7)}`;
    if (s.length === 10) return `(${s.slice(0, 2)}) ${s.slice(2, 6)}-${s.slice(6)}`;
    return d;
  },
};

/** Máscara progressiva de CNPJ para o campo de digitação. */
export function maskCnpj(v: string) {
  const d = v.replace(/\D/g, '').slice(0, 14);
  return d
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/\.(\d{3})(\d)/, '.$1/$2')
    .replace(/(\d{4})(\d)/, '$1-$2');
}

export function slugify(v: string) {
  return v
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);
}
